(function () {
  const root = document.getElementById('my-chatbot-root');
  if (!root) return;

  // Config from data-* attributes (edit in the snippet)
  const BOT_NAME = root.dataset.botName || 'Helper';
  const API_BASE = root.dataset.apiBase || '/apps/chatbot/proxy'; 
  // If you host externally, e.g. 'https://api.example.com/chat', set it above.

  // Storage key per visitor
  const STORE_KEY = 'my_chatbot_history_v1';

  // Create UI
  const launcher = document.createElement('button');
  launcher.className = 'cb-launcher';
  launcher.setAttribute('aria-label', 'Open chat');
  launcher.innerHTML = '💬';

  const panel = document.createElement('div');
  panel.className = 'cb-panel';
  panel.setAttribute('role', 'dialog');
  panel.setAttribute('aria-modal', 'false');
  panel.setAttribute('aria-label', BOT_NAME + ' chat');

  panel.innerHTML = `
    <div class="cb-header">
      <div class="cb-title">${BOT_NAME}</div>
      <button type="button" class="cb-close" aria-label="Close">✕</button>
    </div>
    <div class="cb-body" id="cb-body" tabindex="0" ></div>
    <form class="cb-footer" id="cb-form">
      <input class="cb-input" id="cb-input" type="text" placeholder="Type a message…" autocomplete="off" aria-label="Message" />
      <button class="cb-send" type="submit">Send</button>
    </form>
  `;

  document.body.appendChild(launcher);
  document.body.appendChild(panel);

  const bodyEl = panel.querySelector('#cb-body');
  const inputEl = panel.querySelector('#cb-input');
  const formEl = panel.querySelector('#cb-form');
  const closeBtn = panel.querySelector('.cb-close');

  // Helpers
  const scrollToBottom = () => bodyEl.scrollTop = bodyEl.scrollHeight;

  const loadHistory = () => {
    try { return JSON.parse(localStorage.getItem(STORE_KEY) || '[]'); }
    catch { return []; }
  };
  const saveHistory = (h) => localStorage.setItem(STORE_KEY, JSON.stringify(h));

  const renderMsg = (role, text) => {
    const wrap = document.createElement('div');
    wrap.className = `cb-msg ${role}`;
    const bubble = document.createElement('div');
    bubble.className = 'cb-bubble';
    bubble.textContent = text;
    wrap.appendChild(bubble);
    bodyEl.appendChild(wrap);
    scrollToBottom();
  };

  const setTyping = (on) => {
    if (on) {
      if (!panel.querySelector('.cb-typing')) {
        const tip = document.createElement('div');
        tip.className = 'cb-typing';
        tip.textContent = `${BOT_NAME} is typing…`;
        tip.setAttribute('data-typing', '1');
        bodyEl.appendChild(tip);
        scrollToBottom();
      }
    } else {
      const tip = panel.querySelector('.cb-typing');
      if (tip) tip.remove();
    }
  };

  // Initialize
  const history = loadHistory();
  if (history.length === 0) {
    // Optional greeting
    renderMsg('bot', `Hi! I’m ${BOT_NAME}. How can I help you today?`);
  } else {
    history.forEach(m => renderMsg(m.role, m.text));
  }

  // Toggle open/close
  const open = () => {
    panel.classList.add('is-open');
    panel.setAttribute('aria-modal', 'true');
    inputEl.focus();
  };
  const close = () => {
    panel.classList.remove('is-open');
    panel.setAttribute('aria-modal', 'false');
  };

  launcher.addEventListener('click', () => {
    if (panel.classList.contains('is-open')) close(); else open();
  });
  closeBtn.addEventListener('click', close);

  // Send logic
  // --- New Helper for Unique Message IDs ---
  const generateMessageId = () => {
    return Date.now().toString() + Math.floor(Math.random() * 1000).toString();
  };

  // --- New Helper for Persistent Channel ID (Session based) ---
  const getChannelId = () => {
    let id = localStorage.getItem('digbi_external_channel_id');
    if (!id) {
      id = 'chat_' + Math.random().toString(36).substr(2, 9);
      localStorage.setItem('digbi_external_channel_id', id);
    }
    return id;
  };

  // --- Updated Send Logic ---
  async function sendToBot(userText) {
    const API_URL = 'https://java-services-staging.goodforme.ai:8000/v1/pubnub/agent';
    
    // IMPORTANT: Note on 'state-02' header
    // Browsers often block custom headers unless the server allows them via CORS.
    const headers = {
      'Content-Type': 'application/json',
      'state-02': 'nYP4f5fhe/7NFjZtLxA+ecBxwUJsqO2xic5vUJlz5KM=' // token
    };

    const payload = {
      "channelId": getChannelId(),
      "messageId": generateMessageId(),
      "message": userText,
      "agentId": "DIGBI_EXTERNAL_CHAT_AGENT",
      "featureContext": "ASK_DIGBI"
    };

    try {
      const res = await fetch(API_URL, {
        method: 'POST',
        headers: headers,
        body: JSON.stringify(payload)
      });

      if (!res.ok) {
        throw new Error(`Server Error: ${res.status}`);
      }

      const data = await res.json();

      /** * NOTE: Based on your cURL, I am assuming the response 
       * contains the answer in a field like 'response' or 'text'.
       * Adjust 'data.response' below to match your actual API output.
       */
      return data.response || data.message || "I received your message but don't have a response.";

    } catch (err) {
      console.error("Chatbot API Error:", err);
      return "I'm having trouble connecting to my brain. Please try again in a moment.";
    }
  }

  formEl.addEventListener('submit', async (e) => {
    e.preventDefault();
    const text = (inputEl.value || '').trim();
    if (!text) return;
    inputEl.value = '';

    // Render user message & persist
    renderMsg('user', text);
    const newHist = [...loadHistory(), { role: 'user', text }];
    saveHistory(newHist);

    // Call bot
    setTyping(true);
    try {
      const reply = await sendToBot(text);
      renderMsg('bot', reply);
      saveHistory([...loadHistory(), { role: 'bot', text: reply }]);
    } catch (err) {
      renderMsg('bot', 'Network error. Please try again.');
      console.error(err);
    } finally {
      setTyping(false);
    }
  });

  // Close on Escape
  window.addEventListener('keydown', (e) => {
    if (e.key === 'Escape' && panel.classList.contains('is-open')) close();
  });
})();
